export const CARGAR_COBRAZA = 'CARGAR_COBRAZA';
export const CARGAR_MOVIMIENTOSCAJA = 'CARGAR_MOVIMIENTOSCAJA';